import { Component, computed, input } from '@angular/core';
import {
  ConsumptionFilter,
  getSelectedFrom,
  getSelectedTo,
  LoadCurveState,
} from '../../stores/consumption.store';
import { Skeleton } from 'excellence-ui';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { TranslocoPipe } from '@jsverse/transloco';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-analysis-consumption-details-kpi-card',
  imports: [Skeleton, ErrorComponent, GermanNumberPipe, TranslocoPipe, DatePipe],
  templateUrl: './analysis-consumption-details-kpi-card.html',
})
export class AnalysisConsumptionDetailsKpiCard {
  filter = input.required<ConsumptionFilter>();
  state = input.required<LoadCurveState | null>();

  protected selectedFrom = computed(() => getSelectedFrom(this.filter()));
  protected selectedTo = computed(() => getSelectedTo(this.filter()));
}
